import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { FeedbackList, suggestedArea } from '@/features/feedback';

import styles from './FeedbackPage.module.css';

export function FeedbackPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const area = suggestedArea(location.state);
  const state = area ? { feedbackArea: area } : undefined;
  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <div>
          <h1 className={styles.title}>{t('feedback.title')}</h1>
          <p className={styles.lead}>{t('feedback.lead')}</p>
        </div>
        <Link className={styles.primary} to="/app/feedback/new" {...(state && { state })}>
          {t('feedback.new')}
        </Link>
      </header>
      <FeedbackList />
    </div>
  );
}
